import { useContext } from 'react';

import { BreadcrumbStateContext } from 'components/shared/Breadcrumb/context/BreadcrumbContext';

// Accessible name for the dialog. A `contentLabel` prop passed to Modal still wins (it reaches ReactModal via rest).
const useContentLabel = (title, customTitle) => {
  const breadcrumbState = useContext(BreadcrumbStateContext);

  if (typeof title === 'string') return title;
  if (typeof customTitle === 'string') return customTitle;
  // Breadcrumb-headed modals render their title through `BreadcrumbList`; the root step names the dialog.
  const rootTitle = breadcrumbState?.steps?.[0]?.title;
  if (typeof rootTitle === 'string') return rootTitle;
  return 'Modal';
};

export default useContentLabel;
